export default function ({ redirect, app }) {
  if (app.$auth.passwordChangeIsRequired()) {
    return Promise.resolve()
  }
  return redirect(app.localePath('index'))
}
